export { default } from './InputSubLabel';
